import { apiRequest } from "./apiClient";

export function listAppParams(type) {
  const query = type ? `?type=${encodeURIComponent(type)}` : "";
  return apiRequest(`/api/app-params${query}`);
}

export function createAppParam(values) {
  return apiRequest("/api/app-params", { method: "POST", body: JSON.stringify(values) });
}

export function updateAppParam(id, values) {
  return apiRequest(`/api/app-params/${id}`, { method: "PUT", body: JSON.stringify(values) });
}

export function deleteAppParam(id) {
  return apiRequest(`/api/app-params/${id}`, { method: "DELETE" });
}
